import { takeLatest, put, call } from 'redux-saga/effects';

import { findAnimalRacaCadastro } from '../service';
import {
  FIND_ANIMAL_RACA_CADASTRO,
  FIND_ANIMAL_RACA_CADASTRO_PENDING,
  FIND_ANIMAL_RACA_CADASTRO_SUCCESS,
  FIND_ANIMAL_RACA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindAnimalRacaCadastro(action) {
  yield put({ type: FIND_ANIMAL_RACA_CADASTRO_PENDING, id: action.id })

  try {
    const registro = yield call(findAnimalRacaCadastro, action.id);
    yield put({ type: FIND_ANIMAL_RACA_CADASTRO_SUCCESS, registro: registro })
  } catch (error) {
    yield put({ type: FIND_ANIMAL_RACA_CADASTRO_FAILURE })
  }
}

export default function* watchFindAnimalRacaCadastro() {
  yield takeLatest(FIND_ANIMAL_RACA_CADASTRO, sagaFindAnimalRacaCadastro)
}
